const ProjectModel = require("@/appModel/project/ProjectModel");
const UserModel = require("@/appModel/users/UserModel")
const SortUtil = require("@/appUtils/SortUtil")
// const short = require("short-uuid")

class ProjectEditViewModel {
  constructor(tenantId) {
    this.tenantId = tenantId
    this.isNew = true 
    this.userName = ""
    this.email = ""
  }
  async init(sk = null, isCopy = false) {
   
    // 新規フラグ更新
    this.isNew = !sk || isCopy
    
    if (sk) {
      // DBから取得
      try {
        this.data = await ProjectModel.getProject(sk, this.tenantId)

        if (isCopy) {
          // コピーデータを作成するため、skだけ新規採番する
          const tmp = await ProjectModel.getNewData()
          this.data.sk = tmp.sk
          // フォーム名にcopyを付与
          this.data.project.name += `-Copy`

        }
      } catch (e) {
        console.log(`ProjectEditViewModel init error ${e}`)
        throw e
      }
      
    } else {
      // 新規レコード
      this.data = await ProjectModel.getNewData()
      
    }

    // ユーザ情報を取得
    await this.setMemberList()
  }
  async save() {
    try {

      if (this.isNew) {
        // 新規追加
        await ProjectModel.addProject(this.data)
      } else {
        // 更新
        await ProjectModel.updateProject(this.data)
      }
    } catch (e) {
      console.log(`ProjectEditViewModel save error:${JSON.stringify(e)}`)
      throw e
    }
  }
  async getUserList() {
    console.log(`getUserList ${this.userList.length}`)
    // 検索条件が指定されている場合のみフィルターする
    let userList = this.userList
    if (this.userName || this.email) {
      userList = this.userList.filter(function(item){
        let userFlg = true
        let emailFlg = true
        try {
          if (this.userName){
            if (item.user.name) {
              userFlg = item.user.name.indexOf(this.userName) >= 0
            } else {
              userFlg = false
            }
          }
  
          if (this.email){
            if (item.user.email) {
              emailFlg = item.user.email.indexOf(this.email) >= 0
            } else {
              emailFlg = false
            }
          }
          return userFlg && emailFlg
        } catch (e) {
          console.log(JSON.stringify(e))
        }
        return true
      }.bind(this))
    }
    
    userList = await SortUtil.sort(userList, "user.name", "ascending", true);

    return userList
  }
  async setMemberList() {
    this.userList = await UserModel.getUserList(this.tenantId)
    this.memberList = []
    let userDictionary = {}
    
    this.userList.forEach(function(item) {
      // 削除ユーザは省く
      if (!item.user.deleted) {
        userDictionary[item.user.userId] = Object.assign({}, item.user)
      }
    }.bind(this))

    this.data.project.members.forEach(function(item) {
      if (userDictionary[item.userId]) {
        this.memberList.push({
          authType: item.authType,
          name: userDictionary[item.userId].name,
          userId: userDictionary[item.userId].userId,
          usertype: userDictionary[item.userId].usertype,
          status: userDictionary[item.userId].status,
          email: userDictionary[item.userId].email
        })
      }
    }.bind(this))
  }
}
module.exports = ProjectEditViewModel;